import React, { FC, ReactElement } from "react"
import Spinner from "../../Components/Spinner/Spinner"
import { ButtonProps } from "./Button.types"
import { Icon } from "@zambezi/sdk/icons"

import "./Button.scss"
import { Link } from "react-router-dom"

const Button: FC<ButtonProps> = ({
    is,
    children,
    className,
    loading,
    icon,
    iconProps,
    iconPosition,
    buttonSize = "large",
    ...props
}: ButtonProps) => {
    let klass = `zb-button zb-button-${is} ${className || ""}`

    if (icon) {
        klass += ` zb-button-with-icon-${iconPosition}`

        if (!children) {
            klass += ` zb-button-icon-only`

            switch (buttonSize) {
                case "small":
                    klass += " zb-button-icon-only-small"
                    break
                case "medium":
                    klass += " zb-button-icon-only-medium"
                    break
                case "large":
                default:
                    klass += " zb-button-icon-only-large"
                    break
            }
        }
    }

    /**
     * Renders the button contents based on props
     *
     * @returns {ReactElement} The rendered content
     */
    function renderContent(): ReactElement {
        return (
            <>
                {icon && iconPosition === "before" && (
                    <Icon name={icon} title="" {...iconProps} />
                )}
                {children && <span>{children}</span>}
                {icon && iconPosition === "after" && (
                    <Icon name={icon} title="" {...iconProps} />
                )}
                {loading && (
                    <Spinner
                        inverted={is === "primary"}
                        style={{
                            height: "1em",
                            width: "1em",
                            verticalAlign: "text-bottom",
                            marginLeft: "8px",
                        }}
                    />
                )}
            </>
        )
    }

    if (props.as === "a") {
        const { as, ...htmlProps } = props
        return (
            <a className={klass} {...htmlProps}>
                {renderContent()}
            </a>
        )
    } else if (props.as === "link") {
        const { as, ...linkProps } = props
        return (
            <Link className={klass} {...linkProps}>
                {renderContent()}
            </Link>
        )
    } else {
        const { as, ...htmlProps } = props
        return (
            <button className={klass} {...htmlProps}>
                {renderContent()}
            </button>
        )
    }
}

Button.defaultProps = {
    iconPosition: "before",
}

export default Button
